import React, { useState, useEffect, useRef } from 'react';
import HighFidelityYieldChart from './HighFidelityYieldChart';
import apiClient from '../../services/apiClient';
import { fetchYieldCurveSnapshot } from '../../utils/yieldApiUtils';

const StateGovernmentYieldChartRedesign = ({ showTrades = true }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [topFaceValues, setTopFaceValues] = useState([]);
  const [tradeDate, setTradeDate] = useState('');
  const chartRef = useRef(null);

  const fetchYieldData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const payload = await fetchYieldCurveSnapshot(apiClient, baseUrl, 'SDL');

      if (payload?.yieldData && Array.isArray(payload.yieldData)) {
        setApiData(payload.yieldData);
        const topFaceValuesData = payload.topFaceValues || [];
        setTopFaceValues(topFaceValuesData);
        setTradeDate(payload.date || (topFaceValuesData.length > 0 ? topFaceValuesData[0].tradeDate : ''));
      } else {
        throw new Error('Invalid API response format');
      }
    } catch (err) {
      console.error('Error fetching SDL yield data:', err);
      setError(err.message || 'Failed to fetch SDL yield data');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      fetchYieldData();
    }
  }, [isVisible]);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, { threshold: 0.1 });
    if (chartRef.current) observer.observe(chartRef.current);
    return () => chartRef.current && observer.unobserve(chartRef.current);
  }, []);

  return (
    <div ref={chartRef} className={`state-government-yield-curve-section ${isVisible ? 'visible' : ''}`}>
      <HighFidelityYieldChart 
        title="State Government Securities Yield Curve"
        type="SDL"
        apiData={apiData}
        isLoading={isLoading}
        error={error}
        topTrades={showTrades ? topFaceValues : []}
        tradeDate={showTrades ? tradeDate : ''}
      />
    </div>
  );
};

export default StateGovernmentYieldChartRedesign;
